
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scan-cccd-passport",
      function () {
        return require("private-next-pages/scan-cccd-passport.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scan-cccd-passport"])
      });
    }
  